import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'transport'
})
export class TransportPipe implements PipeTransform {

  transform(value: any, ...args: any[]): any {
    switch (value) {
      case 'FOOT':
        return 'Foot';
      case 'BIKE':
        return 'Bike';
      case 'MOPED':
        return 'Moped';
      case 'SCHOOLBUS':
        return 'School Bus';
      case 'BUS_TRAM_METRO':
        return 'Bus/Tram/Metro';
      case 'TRAIN':
        return 'Train';
      case 'CAR':
        return 'Car';
      case 'OTHER':
        return 'Other';
      default:
        return '';
    }
  }

}
